import {AnyAction} from 'redux';
import {CONTRACT_NEW, CONTRACT_UPDATE} from 'redux/actions/contract';
import {ContractState, FahrzeugType, SalesType, Zahlweise} from '../../types/redux';
import {getCookieValue} from '../../lib/getCookieValue';
import {DmsApiData} from './DmsApiData';
import {CONTRACT_PRICE_CALC_DONE} from "../actions/contractPrices";

function mapDmsToContractData(dmsData: DmsApiData) {
	return {
		partnerId: dmsData.partnerId,
		partnerNumber: dmsData.partnerNumber,
		vorname: dmsData.name || '',
		name: dmsData.surname || '',
		email: dmsData.email || '',
		telefonnummer: dmsData.telephone || '',
		geburtsdatum: dmsData.birthDate || '',
		street: dmsData.streetName || '',
		streetNumber: dmsData.streetNumber || '',
		plz: dmsData.postalCode || '',
		ort: dmsData.addressLocality || '',
		iban: dmsData.iban || '',
		neufahrzeug: dmsData.isNewCar === 'true',
	};
}

const initialState: ContractState = {
	salesType: SalesType.UNDEFINED,
	prozessId: '',
	laufzeit: 36,
	zahlweise: Zahlweise.MB,
	kaufpreis: 0,
	kaufdatum: '',
	zulassungsdatum: '',
	beginndatum: '',
	fahrzeugtyp: FahrzeugType.P,
	neufahrzeug: true,
	beitrag: -1,
	ausweisType: '',
	ausweisId: '',
	vorname: '',
	name: '',
	email: '',
	kaufvertragsnummer: '',
	telefonnummer: '',
	geburtsdatum: '',
	strasse: '',
	street: '',
	streetNumber: '',
	plz: '',
	ort: '',
	launchUrl: '',
	iban: '',
	bic: '',
	bank: '',
	earliestRegistrationDate: '',
};

export function contractReducer(
	state: ContractState = initialState,
	action: AnyAction
): ContractState {
	switch (action.type) {
		case CONTRACT_NEW:
			const dmsDataString = getCookieValue('dms-data');
			if (dmsDataString) {
				// if available use cookie data from dms to fill customer specific fields
				const dmsData: DmsApiData = JSON.parse(dmsDataString);
				return {
					...initialState,
					...mapDmsToContractData(dmsData),
					salesType: action.payload.type,
				};
			}
			if(action.type === CONTRACT_NEW && (new Set([SalesType.EPH, SalesType.EPK])).has(action.payload.type)) {
				return {
					...initialState,
					zahlweise: undefined,
					laufzeit: undefined,
					fahrzeugtyp: undefined,
					neufahrzeug: undefined,
					salesType: action.payload.type,
				}
			}
			return {
				...initialState,
				salesType: action.payload.type,
			};
		case CONTRACT_PRICE_CALC_DONE:
			return {
				...state,
				beitrag: action.payload.beitrag,
				prozessId: action.payload.prozessId
			};
		case CONTRACT_UPDATE:
			return {
				...state,
				...action.payload,
			};

		default:
			return state;
	}
}
